import { useContext } from "react";
import MainContext from "../../../../Context/MainContext/MainContext";
import Role from "../../../../Utility/Crud/Role";
import Card from "../../../Card";
import MUIBox from "@mui/material/Box";
import MUITable from "@mui/material/Table";
import MUITableBody from "@mui/material/TableBody";
import MUITableCell from "@mui/material/TableCell";
import MUITableContainer from "@mui/material/TableContainer";
import MUITableHead from "@mui/material/TableHead";
import MUITableRow from "@mui/material/TableRow";
import MUICheckbox from "@mui/material/Checkbox";
import MUIPaper from "@mui/material/Paper";

export default function CardAdminPermissionRoles(props) {
  const context = useContext(MainContext);

  const roles = Role.sort(
    context.rolesIndexed ? Object.values(context.rolesIndexed) : [],
  );
  const selectedRoleIdsSet = new Set(
    (props.selectedRoleIds || []).map((roleId) => String(roleId)),
  );

  const handleToggleRole = (roleId, checked) => {
    const nextSelectedRoleIdsSet = new Set(selectedRoleIdsSet);
    if (checked) {
      nextSelectedRoleIdsSet.add(String(roleId));
    } else {
      nextSelectedRoleIdsSet.delete(String(roleId));
    }

    const nextSelectedRoleIds = Array.from(nextSelectedRoleIdsSet).map(
      (id) => +id,
    );
    props.onChange(nextSelectedRoleIds);
  };

  const renderContent = () => (
    <MUIBox sx={{ overflowX: "auto" }}>
      <MUITableContainer component={MUIPaper} elevation={0}>
        <MUITable size="small">
          <MUITableHead
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
            <MUITableRow>
              <MUITableCell
                padding="checkbox"
                sx={{ width: 56 }}
              ></MUITableCell>
              <MUITableCell sx={{ width: "35%" }}>Name</MUITableCell>
              <MUITableCell>Description</MUITableCell>
            </MUITableRow>
          </MUITableHead>
          <MUITableBody>
            {roles.map((role) => (
              <MUITableRow
                key={role.id}
                hover={true}
                onClick={() =>
                  handleToggleRole(
                    role.id,
                    !selectedRoleIdsSet.has(String(role.id)),
                  )
                }
                sx={{ cursor: "pointer" }}
              >
                <MUITableCell padding="checkbox">
                  <MUICheckbox
                    size="small"
                    checked={selectedRoleIdsSet.has(String(role.id))}
                    onChange={() => {}}
                  />
                </MUITableCell>
                <MUITableCell>{role.name ?? ""}</MUITableCell>
                <MUITableCell>{role.description ?? ""}</MUITableCell>
              </MUITableRow>
            ))}
          </MUITableBody>
        </MUITable>
      </MUITableContainer>
    </MUIBox>
  );

  return <Card renderContent={renderContent} getTitle={() => "Roles"} />;
}
